import * as yup from 'yup';
import forEach from 'lodash.foreach';
import filter from 'lodash.filter';

export function OneFormBudgetVoteValidationSchema() {
	return yup.object().shape({
		emailConfirmationWhileVotingNotLoggedUser: yup.boolean(),
		loggedUserId: yup.number(),
		authorizeCode: yup
			.string()
			.when(
				[ 'emailConfirmationWhileVotingNotLoggedUser', 'loggedUserId' ],
				(emailConfirmationWhileVotingNotLoggedUser, loggedUserId) =>
					emailConfirmationWhileVotingNotLoggedUser && loggedUserId === 0
						? yup.string().required('Kod autoryzacji jest wymagany')
						: yup.string().nullable()
			),

		consultationForms: yup
			.array()
			.of(ConsultationFormBudgetValidationSchema())
			.min(1, 'Budżet musi zawierać przynajmniej jeden obszar')
			.test('No answers', 'Głosowanie nie ma żadnej odpowiedzi', function(forms) {
				const noAnswer = 0;
				let answerOptionPoints = [];
				forEach(forms, (form) => {
					forEach(form.categories, (category) => {
						forEach(category.questions, (question) => {
							forEach(question.answers, (answer) => {
								forEach(answer.answerOptions, (answerOption) => {
									let point = parseInt(answerOption.openText) || 0;
									answerOptionPoints.push(point);
								});
							});
						});
					});
				});

				return answerOptionPoints.some((item) => item !== noAnswer);
			})
	});
}

export function ConsultationFormBudgetValidationSchema() {
	return yup.object().shape({
		categories: yup
			.array()
			.of(CategoryBudgetValidationSchema())
			.min(1, 'Budżet musi zawierać przynajmniej jedną kategorię'),
		maxPoint: yup
			.number()
			.required('To musi być liczba')
			.typeError('To musi być liczba')
			.min(1, 'Maksymalna ilość punktów musi być większa od 0')
			.test(
				'Prevent greater maxPoint on category',
				'Maksymalna ilość punktów na obszar musi być większa lub równa każdej maksymalnej ilości punktów z kategorii',
				function(maxPoint) {
					let categories = this.resolve(yup.ref('categories'));
					let maxPointsFromCategories = filter(categories, (category) => category.maxPoint > (maxPoint || 0));

					return maxPointsFromCategories.length === 0;
				}
			)
			.test(
				'Prevent sum points of category greater then max point on budget',
				'Suma punktów przekracza maksymalną ilość punktów na obszar',
				function(maxPoint) {
					let categories = this.resolve(yup.ref('categories'));
					let sumPoints = 0;
					forEach(categories, (category) => {
						forEach(category.questions, (question) => {
							forEach(question.answers, (answer) => {
								forEach(answer.answerOptions, (answerOption) => {
									let point = parseInt(answerOption.openText) || 0;
									sumPoints += point;
								});
							});
						});
					});

					return sumPoints <= maxPoint;
				}
			)
	});
}

function CategoryBudgetValidationSchema() {
	return yup.object().shape({
		maxPoint: yup
			.number()
			.required('To musi być liczba')
			.typeError('To musi być liczba')
			.min(1, 'Maksymalna ilość punktów musi być większa od 0')
			.test(
				'Prevent sum points of qustions greater then max point on category',
				'Suma punktów przekracza maksymalną ilość punktów dla kategorii',
				function(maxPoint) {
					let questions = this.resolve(yup.ref('questions'));
					let sumPoints = 0;
					forEach(questions, (question) => {
						forEach(question.answers, (answer) => {
							forEach(answer.answerOptions, (answerOption) => {
								let point = parseInt(answerOption.openText) || 0;
								sumPoints += point;
							});
						});
					});

					return sumPoints <= maxPoint;
				}
			),
		questions: yup
			.array()
			.of(QuestionBudgetValidationSchema())
			.min(1, 'Kategoria musi zawierać przynajmniej jeden projekt')
	});
}

function QuestionBudgetValidationSchema() {
	return yup.object().shape({
		maxPoint: yup
			.number()
			.required('To musi być liczba')
			.typeError('To musi być liczba')
			.min(1, 'Maksymalna ilość punktów musi być większa od 0'),
		answers: yup
			.array()
			.of(
				yup.object().shape({
					answerOptions: yup.array().of(
						yup.object().shape({
							openText: yup.number().typeError('To musi być liczba').required('To musi być liczba')
						})
					)
				})
			)
			.min(1, 'Brak odpowiedzi na pytanie')
			.test('AnswerOption greater than max point', 'Przekroczono ilość punktów dla projektu', function(answers) {
				const maxPoint = this.resolve(yup.ref('maxPoint'));
				let answerOptionPoints = [];
				forEach(answers, (answer) => {
					forEach(answer.answerOptions, (answerOption) => {
						let point = parseInt(answerOption.openText) || 0;
						answerOptionPoints.push(point);
					});
				});

				return answerOptionPoints.every((item) => item <= maxPoint);
			})
			.test('AnswerOption lower than zero', 'Liczba punktów nie może być mniejsza od 0', function(answers) {
				const maxPoint = 0;
				let answerOptionPoints = [];
				forEach(answers, (answer) => {
					forEach(answer.answerOptions, (answerOption) => {
						let point = parseInt(answerOption.openText) || 0;
						answerOptionPoints.push(point);
					});
				});

				return answerOptionPoints.every((item) => item >= maxPoint);
			})
		// .test('No answers', 'Brak odpowiedzi na pytanie', function(answers) {
		// 	const noAnswer = 0;
		// 	let answerOptionPoints = [];
		// 	forEach(answers, (answer) => {
		// 		forEach(answer.answerOptions, (answerOption) => {
		// 			let point = parseInt(answerOption.openText) || 0;
		// 			answerOptionPoints.push(point);
		// 		});
		// 	});

		// 	return answerOptionPoints.some((item) => item !== noAnswer);
		// })
	});
}
